import { render, staticRenderFns } from "./ItemDetailMainSlideLayout.vue?vue&type=template&id=20097fdb&scoped=true"
import script from "./ItemDetailMainSlideLayout.vue?vue&type=script&lang=js"
export * from "./ItemDetailMainSlideLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20097fdb",
  null
  
)

export default component.exports